/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Notfound_TitleInputs */

const en_invite_notfound_title = /** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite link is not valid`)
};

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const ar_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const he_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const ur_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const es_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const fr_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const de_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const pt_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const hi_invite_notfound_title = en_invite_notfound_title;

/** @type {(inputs: Invite_Notfound_TitleInputs) => LocalizedString} */
const bn_invite_notfound_title = en_invite_notfound_title;

/**
* | output |
* | --- |
* | "This invite link is not valid" |
*
* @param {Invite_Notfound_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_notfound_title = /** @type {((inputs?: Invite_Notfound_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Notfound_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_notfound_title(inputs)
	if (locale === "he") return he_invite_notfound_title(inputs)
	if (locale === "ur") return ur_invite_notfound_title(inputs)
	if (locale === "es") return es_invite_notfound_title(inputs)
	if (locale === "fr") return fr_invite_notfound_title(inputs)
	if (locale === "de") return de_invite_notfound_title(inputs)
	if (locale === "pt") return pt_invite_notfound_title(inputs)
	if (locale === "hi") return hi_invite_notfound_title(inputs)
	if (locale === "bn") return bn_invite_notfound_title(inputs)
	return /** @type {LocalizedString} */ ("This invite link is not valid")
});